import moment from "moment";
import React from "react";
import Box from "@mui/material/Box";
import GrAvatar from "src/design-system/components/GrAvatar";
import GrBadge from "src/design-system/components/GrBadge";
import { gr } from "src/design-system/tokens";

// Author line of a feed post (feed, dashboard, post popup / page): avatar, name 14/600 with an
// "Admin" / "Coach" badge for staff, and the post date (12, muted) under the name.
const rootSx = {
  display: "flex",
  alignItems: "center",
  gap: gr.space[3],
  minWidth: 0,
  fontFamily: gr.font.family,
};
const textSx = { display: "grid", gap: gr.space[1], minWidth: 0 };
const nameRowSx = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: gr.space[2],
};
const nameSx = {
  fontSize: gr.font.size.md,
  fontWeight: gr.font.weight.semibold,
  lineHeight: gr.font.lineHeight.tight,
  color: gr.color.ink,
  overflowWrap: "anywhere",
};
const dateSx = {
  fontSize: gr.font.size.xs,
  lineHeight: gr.font.lineHeight.normal,
  color: gr.color.muted,
};

export default function UserInfoCard({
  profile_image,
  user_name,
  date,
  avatar_char,
  type,
}) {
  return (
    <Box sx={rootSx} className="user-info-card">
      <GrAvatar src={profile_image} name={avatar_char || user_name} />
      <Box sx={textSx}>
        <Box sx={nameRowSx}>
          <Box component="span" sx={nameSx}>
            {user_name}
          </Box>
          {type !== "member_user" && (
            <GrBadge tone="brand">
              {type === "admin_user" ? "Admin" : "Coach"}
            </GrBadge>
          )}
        </Box>
        {date && (
          <Box component="span" sx={dateSx}>
            {moment(date).format("DD MMM YYYY [at] hh:mm A")}
          </Box>
        )}
      </Box>
    </Box>
  );
}
